// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type {
  DecisioningStudioDimensionActionResultItem,
  PostDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult,
} from "./types";

const isNull = (v: unknown): v is null => v === null;
const isBoolean = (v: unknown): v is boolean => typeof v === "boolean";

const isDimensionActionField = objectOf({
  name: string,
  value: anyOf(string, number, isBoolean, isNull),
});

const isDimensionActionResultItem = objectOf<DecisioningStudioDimensionActionResultItem>({
  id: string,
  key: string,
  fields: arrayOf(isDimensionActionField),
  created_at: string,
  updated_at: string,
});

export const isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult = objectOf({
  hits: number,
  results: arrayOf(isDimensionActionResultItem),
});

export const isPostDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult =
  objectOf<PostDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult>({
    data: objectOf({
      action_id: number,
      action_status: string,
      created_date: string,
      fields: arrayOf(isDimensionActionField),
    }),
    meta: isNull,
  });

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult>({
    data: arrayOf(isDimensionActionResultItem),
    meta: objectOf({
      pagination: objectOf({
        total: number,
        offset: anyOf(number, isNull),
        limit: anyOf(number, isNull),
      }),
      extra: isNull,
    }),
  });
